const container = document.querySelector('.cc-refund-policy .shopify-policy__container');
if (container && !container.querySelector('.cc-policy-nav')) {
  const items = [...container.querySelectorAll('.shopify-policy__body ol > li')];
  if (items.length) {
    const nav = document.createElement('nav');
    nav.className = 'cc-policy-nav';
    nav.setAttribute('aria-label', 'Innehåll i återbetalningspolicyn');
    const label = document.createElement('p');
    label.textContent = 'På den här sidan';
    nav.append(label);
    const list = document.createElement('ol');
    items.forEach((item, index) => {
      const title = item.querySelector('strong');
      if (!title) return;
      const id = 'returvillkor-' + (index + 1);
      item.id = id;
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + id;
      const number = document.createElement('span');
      number.textContent = String(index + 1).padStart(2, '0');
      number.setAttribute('aria-hidden', 'true');
      link.append(number, document.createTextNode(title.textContent.trim().replace(/:$/, '')));
      li.append(link);
      list.append(li);
    });
    nav.append(list);
    container.insertBefore(nav, container.querySelector('.shopify-policy__body'));
  }
}
